// extracted by mini-css-extract-plugin
export default {"modalOverlay":"ModalOverlay_modalOverlay__yvldh","synod":"ModalOverlay_synod__eTNbD","hidden":"ModalOverlay_hidden__Q3BXE","inner":"ModalOverlay_inner__-73tY"};